import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { about, allInOne, barkodOxuyucu, barkodPrinter, barkodProcessor, cardReader, carousel2, dataTerminal, hero, pulQutulari, blogs1, blogs2, blogs3, project1, project2, project3, project4, project5, project6, rightArrow, service1, service2, service3, service4 } from '../../assets/index';
import { useTranslation } from 'react-i18next';
import HeaderOther from '../../Components/HeaderOther/HeaderOther';
import Title from '../../Components/Title/Title';


const Services = () => {

  const { t, i18n } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);
  return (
   <>
   <HeaderOther/>
   <Title title="Xidmətlər"/>
   <div className='max-w-containerSm md:max-w-container mx-auto pt-[214px] md:pt-[260px]'>
   <p className='text-[24px] md:text-[40px] font-bold md:font-semibold text-center mb-10 font-barlow'>Sizə Xüsusi Təqdim Etdiyimiz <span className='font-barlow text-[#E11E26]'>Xidmətlər</span></p>
    <div className='grid grid-cols-1 md:grid-cols-4 gap-6'>
  <div className='md:w-[315px] md:h-[263px] rounded-[20px] px-[20px] py-[20px] mt-[9px] md:mt-0 border-[2px] border-[#F1F1F1] flex justify-center items-center'>
   <div>
   <div className='flex items-center'>
   <img className='w-10 h-10' src={service1}></img>
   <p className='text-[18px] md:text-[20px] font-medium text-black ml-4'>Gözəllik salonları</p>
   </div>
   <p className='mt-[16px] text-base text-[#999999]'>Gözəlliyinizə peşəkar toxunuş. Rahat və keyfiyyətli qulluq.</p>
   </div>
   </div>
   <div className='md:w-[315px] md:h-[263px] rounded-[20px] px-[20px] py-[20px] mt-[9px] md:mt-0 border-[2px] border-[#F1F1F1] flex justify-center items-center'>
   <div>
   <div className='flex items-center'>
   <img className='w-10 h-10' src={service2}></img>
   <p className='text-[18px] md:text-[20px] font-medium text-black ml-4'>Fitness Mərkəzi</p>
   </div>
   <p className='mt-[16px] text-base text-[#999999]'>Müasir avadanlıqlarla gücünüzü artırın. Sağlamlığınızı qoruyun.</p>
   </div>
   </div>
   <div className='md:w-[315px] md:h-[263px] rounded-[20px] px-[20px] py-[20px] mt-[9px] md:mt-0 border-[2px] border-[#F1F1F1] flex justify-center items-center'>
   <div>
   <div className='flex items-center'>
   <img className='w-10 h-10' src={service3}></img>
   <p className='text-[18px] md:text-[20px] font-medium text-black ml-4'>Hovuz</p>
   </div>
   <p className='mt-[16px] text-base text-[#999999]'>Rahatlıq və dinclik üçün hovuz. Günün yorğunluğunu atın.</p>
   </div>
   </div>
   <div className='md:w-[315px] md:h-[263px] rounded-[20px] px-[20px] py-[20px] mt-[9px] md:mt-0 border-[2px] border-[#F1F1F1] flex justify-center items-center'>
   <div>
   <div className='flex items-center'>
   <img className='w-10 h-10' src={service4}></img>
   <p className='text-[18px] md:text-[20px] font-medium text-black ml-4'>Parkinq</p>
   </div>
   <p className='mt-[16px] text-base text-[#999999]'>Geniş və təhlükəsiz park sahəsi. Rahatlığınızı təmin edirik.</p>
   </div>
   </div>
    
   
    </div>
   </div>  </>
  );
};
 
export default Services; 